export default __webpack_public_path__ + "static/media/img-1.db028703.jpg";